// FinanceMetrics.js
import React from "react";
import { DollarSign } from "lucide-react";
import "./finance-metrics.css";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./ui/tooltip";
import { Info } from "lucide-react";

const FinanceMetrics = ({ balance, revenue, overhead, info }) => {
  const netIncome = revenue - overhead;
  const formattedNetIncome = Math.abs(netIncome).toLocaleString();
  const formattedBalance = Math.abs(balance).toLocaleString();

  return (
    <div className="finance-metrics-box">
      <div className="finance-stat-content">
        <div className="stat-info">
          <div className="stat-header">
            <span className="stat-label">Balance</span>
          </div>
          <div
            className={`stat-value ${balance < 0 ? "negative" : "positive"}`}
          >
            {balance < 0 ? "-$" : "$"}
            {formattedBalance}
          </div>
        </div>

        <div className="metrics-grid">
          <div className="metric-column">
            <span className="metric-label">Revenue:</span>
            <span className="metric-value positive">
              ${revenue.toLocaleString()}
            </span>
          </div>

          <div className="operator">−</div>

          <div className="metric-column">
            <span className="metric-label">Overhead:</span>
            <span className="metric-value negative">
              ${overhead.toLocaleString()}
            </span>
          </div>

          <div className="operator">=</div>

          <div className="metric-column">
            <span className="metric-label">Income:</span>
            <span
              className={`metric-value ${
                netIncome < 0 ? "negative" : "positive"
              }`}
            >
              {netIncome < 0 ? "-$" : "$"}
              {formattedNetIncome}
            </span>
          </div>
        </div>
      </div>
      <div className="stat-icons">
        <div className="stat-icon-wrapper">
          <div className="stat-icon-wrapper">
            <DollarSign className="stat-icon" />
          </div>
        </div>
        {info && (
          <div className="info-button-wrapper">
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger>
                  <Info size={20} />
                </TooltipTrigger>
                <TooltipContent>
                  <p>{info}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
        )}
      </div>
    </div>
  );
};

export default FinanceMetrics;
